"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSetNotLinkedToConnection = void 0;
class DataSetNotLinkedToConnection extends Error {
    constructor(dataSetId) {
        super(`Data set ${dataSetId} must be linked to a connection by setting a 'connectionId' property that references a connection in the 'connections' section.`);
        this.name = 'DataSetNotLinkedToConnection';
    }
}
exports.DataSetNotLinkedToConnection = DataSetNotLinkedToConnection;
